/**
 * @function
 * @param m: библиотека с математикой
 * @param d: библиотека со временем
 * @param h: разрядность
 * @param s: рандом
 * @return ObjectId монги
 * Генерируем _id для монги в JS
 */
export function generateMongoDBId(m = Math, d = Date, h = 16, s = (s) => m.floor(s).toString(h)) {
    return s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));
}
